import { render, staticRenderFns } from "./FarmaciaPopup.vue?vue&type=template&id=5580b8e0"
import script from "./FarmaciaPopup.vue?vue&type=script&lang=ts"
export * from "./FarmaciaPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports